import Link from "next/link";
import { useRouter } from "next/router";
import { useTranslations } from "next-intl";
import { useMemo } from "react";

import appRoutes from "~/utils/app-routes";

import styles from "./customer-care.module.scss";

export default function CustomerCare() {
  const t = useTranslations();
  const router = useRouter();
  const isSignUp = useMemo(() => {
    return router.pathname == appRoutes.SIGN_UP;
  }, [router]);

  return (
    <div className={styles.container}>
      {isSignUp && (
        <div>
          {t.rich("signup.resetPassword", {
            gradient: (chunks) => {
              return <span className={styles.gradient}>{chunks?.toString()}</span>;
            },
            link: (chunks) => {
              return (
                <Link href={appRoutes.PASSWORD_RESET_REQUEST} className={styles.link}>
                  {chunks?.toString()}
                </Link>
              );
            },
          })}
        </div>
      )}
      <div>
        {t.rich("generic.customer_care", {
          gradient: (chunks) => {
            return <span className={styles.gradient}>{chunks?.toString()}</span>;
          },
          link: (chunks) => {
            return (
              <Link href={appRoutes.CUSTOMER_HELP_CENTER} className={styles.link}>
                {chunks?.toString()}
              </Link>
            );
          },
        })}
      </div>
    </div>
  );
}
